<template>
  <div id="menu" class="menu">
    <nav class="navbar navbar-expand-lg navbar-light  personal-container d-flex justify-content-between ">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-bs-target="#navbarTogglerDemo03"
              aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation"
              style="background: #343977;">
        <span class="navbar-toggler-icon"></span>
      </button>
      <a class="navbar-brand" href="/">
        <div class="logo">
          <a href="/"><img src="@/assets/images/logo/logo.png" class="w-100" style="max-width: 120px;"
                           alt="Logo de grupo felix"></a>
        </div>
      </a>
      <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <ul class="navbar-nav mr-auto ">
            <li class="nav-item">
              <a class="nav-link font-weight-bold text-light active" href="/">Inicio</a>
            </li>

            <li class="nav-item dropdown" v-on:mouseover="showThisOptions('new_car', true)"
                v-on:mouseout="showThisOptions('new_car', false)">
              <a class="nav-link font-weight-bold text-light">Autos Nuevos</a>
              <div class="sublist_options new_car">
                <div><a href="/autosnuevoschevrolet"><img src="@/assets/images/marcas/chevrolet.png"
                                                          style="height: 25px;" alt="Logo de chevrolet"></a></div>
                <div><a href="/autosnuevoscadillac"><img src="@/assets/images/marcas/cadillac.png" style="height: 25px;"
                                                         alt="Logo de chevrolet"></a></div>
              </div>
            </li>

            <li class="nav-item dropdown">
              <a class="nav-link font-weight-bold text-light" href="/autos-semi-nuevos">Seminuevos</a>
            </li>

            <li class="nav-item dropdown" v-on:mouseover="showThisOptions('promociones', true)"
                v-on:mouseout="showThisOptions('promociones', false)">
              <RouterLink
                to="/promociones"
                active-class="active"
                class="nav-link font-weight-bold text-light"
              >
                Promociones
              </RouterLink>
              <div class="sublist_options2 promociones">
                <div>
                  <p><a href="/financiamiento">Financiamiento</a></p>
                </div>
              </div>
            </li>

            <li class="nav-item dropdown" v-on:mouseover="showThisOptions('postventa', true)"
                v-on:mouseout="showThisOptions('postventa', false)">
              <a class="nav-link font-weight-bold text-light">Postventa</a>
              <div class="sublist_options2 postventa">
                <div>
                  <p><a href=" " target="_blank">Agendar Cita</a></p>
                </div>
                <div>
                  <p><a href="#">Refacciones</a></p>
                </div>
              </div>
            </li>
            <li class="nav-item">
              <RouterLink
                to="/contacto"
                active-class="active"
                class="nav-link font-weight-bold text-light"
              >
                Contacto
              </RouterLink>
            </li>

            <li class="nav-item">
              <div class="form-group">
                <select v-model="suc" @change="cambioSucursal" class="form-control btn btn-outline-light"
                        id="selectCity">
                  <option value="-1" disabled>Selecciona tu ciudad</option>
                  <option value="1">Los Mochis</option>
                  <option value="2">Guasave</option>
                  <option value="3">Culiacán</option>
                  <option value="4">Mazatlán</option>
                </select>
              </div>
            </li>
          </ul>
        </form>
      </div>
    </nav>
  </div>
</template>

<script>

export default {
  name: 'Menu',
  data() {
    return {
      suc: 3
    }
  },
  methods: {
    showThisOptions(arg1, arg2) {
      if (arg2) {
        document.getElementsByClassName(arg1)[0].classList.add('show')
      } else {
        document.getElementsByClassName(arg1)[0].classList.remove('show')
      }
    },
    cambioSucursal(evt) {
      localStorage.setItem('suc', this.suc)
      window.dispatchEvent(new CustomEvent('sucursal-changed', {
        detail: {
          storage: localStorage.getItem('suc')
        }
      }));
    }
  },
  async mounted() {
    this.suc = localStorage.getItem('suc')
  }
}
</script>

<style scoped>
button.btn.btn-light.text-dark.togglebutton.mt-3.position-fixed.d-block.d-md-none.d-lg-none {
  display: none !important;
}

</style>
